import checkInputs from "utils/checkInputs";

export const validationAnnulation = {
  onSubmit: function checkOnSubmit(newEvent) {
    const errors = {};

    if (!checkInputs.notNull(newEvent.cufe)) {
      errors.cufe = "El CUFE del comprobante a ser anulado es necesario.";
    } else if (!checkInputs.isAlphanumeric(newEvent.cufe)) {
      errors.cufe = "No ingrese caracteres especiales.  ('<', '>')";
    } else if (newEvent.cufe.length !== 66) {
      errors.cufe = "Ingrese los 66 caracteres del CUFE.";
    }

    if (!checkInputs.notNull(newEvent.motivo)) {
      errors.motivo = "El motivo es necesario.";
    } else if (!checkInputs.isAlphanumeric(newEvent.motivo)) {
      errors.motivo = "No ingrese caracteres especiales.  ('<', '>')";
    } else if (newEvent.motivo.length < 15 || newEvent.motivo.length > 300) {
      errors.motivo = "No ingrese menos de 15 caracteres ni más de 300 caracteres.";
    }

    return errors;
  },
};

